import { createFileRoute } from '@tanstack/react-router';

import { SupportCenterPage } from '~/modules/support';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

const title = i18n.t(($) => $.pageTitle, { ns: 'support' });

export const Route = createFileRoute('/(main)/support/')({
  component: SupportCenterPage,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const SUPPORT = buildRouteExport({ Route });
